/* eslint-disable @typescript-eslint/no-non-null-assertion */
// eslint-disable-next-line no-restricted-imports
import { Trans } from '@lingui/macro'
import Circle from 'assets/images/white-loader.svg'
import BigNumber from 'bignumber.js'
import confetti from 'canvas-confetti'
import { ButtonLight, ButtonPrimary } from 'components/Button'
import { getTrackBackground, Range } from 'components/Range'
import Toggle from 'components/Toggle'
import { DICE_SUBGRAPH_URL } from 'constants/subgraph'
import request, { gql } from 'graphql-request'
/* import Actions from 'components/reducer/actions'
import { DispatchContext, StateContext } from 'components/reducer/constants' */
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { useDiceContract } from 'hooks/useContract'
import usePlayerData from 'hooks/usePlayerData'
import { useCallback, useEffect, useState } from 'react'
import NumberFormat from 'react-number-format'
import { useWalletModalToggle } from 'state/application/hooks'
import { CustomLightSpinner, ThemedText } from 'theme'
import { BIG_ZERO, DEFAULT_TOKEN_DECIMALS } from 'utils/bigNumber'
import { getFullDisplayBalance } from 'utils/formatBalance'
import { isChainAllowed } from 'utils/switchChain'
import useInterval from 'utils/useInterval'
import { isMobile } from 'utils/userAgent'

import * as StyleDice from '../style'
import HistoryDice from './HistoryDice'
import { ResultModal } from './ResultModal'

const STEP = 1

export const enumBetType = {
  Under: 0,
  Over: 1,
}

const showConfetti = () => {
  confetti({
    particleCount: 250,
    startVelocity: 25,
    gravity: 0.3,
    spread: 350,
    origin: {
      x: 0.5,
      y: 0.3,
    },
  })
}

function DiceBet() {
  const toggleWalletModal = useWalletModalToggle()
  const { account, chainId, connector } = useActiveWeb3React()
  const chainAllowed = chainId && isChainAllowed(connector, chainId)

  const apiUrl = DICE_SUBGRAPH_URL[chainAllowed ? chainId : 137]

  const delay = (ms: number) => new Promise((res) => setTimeout(res, ms))

  const playerData = usePlayerData()

  const [values, setValue] = useState([50])
  const [minValue, setMinValue] = useState(1)
  const [maxValue, setMaxValue] = useState(90)

  const [betType, setBetType] = useState(enumBetType.Under)
  const [winChance, setWinChance] = useState(0)
  const [betColors, setBetColors] = useState(['#b5ff94', '#fd3e3e'])
  const [payoutInCaseWin, setPayoutInCaseWin] = useState(0)
  const [betAmount, setBetAmount] = useState(0)
  const [status, setStatus] = useState(0)
  const [automaticMode, setAutomaticMode] = useState(false)

  const [minBetAmount, setMinBetAmount] = useState(500)
  const [maxBetAmount, setMaxBetAmount] = useState(500 * 10)

  const [loadingPlayBet, setLoadingPlayBet] = useState(false)
  const [attempting, setAttempting] = useState(false)
  const [totalAutoBets, setTotalAutoBets] = useState(2)

  const [randomNumber, setRandomNumber] = useState(0)

  const [pendingResult, setPendingResult] = useState(false)

  const [alertResultLastBet, setAlertResultLastBet] = useState(false)
  const [alertText, setAlertText] = useState('')

  const [requestId, setRequestId] = useState<string | undefined>()
  const [WinNumber, setWinNumber] = useState('00')

  const diceContract = useDiceContract()

  const BigBetAmount = new BigNumber(betAmount).times(DEFAULT_TOKEN_DECIMALS)
  const haveFunds = playerData.chipsBalance.gte(BigBetAmount)

  const hightAmount = betAmount > maxBetAmount

  const [openModal, setOpenModal] = useState(false)
  const [arrayResultNumber, setArrayResultNumber] = useState<any>([])
  const [prize, setPrize] = useState<BigNumber>(BIG_ZERO)
  const [result, setResult] = useState([0])
  const [typeBetResult, setTypeBetResult] = useState<number>()

  const handleDismissModal = useCallback(() => {
    setOpenModal(false)
  }, [setOpenModal])

  useEffect(() => {
    const getLastBet = async (id: string) => {
      const { player } = await request(
        apiUrl,
        gql`
          query GetPlayerBets($address: String!, $id: String!) {
            player(id: $address) {
              bets(where: { id: $id }) {
                winNumber
                prize
              }
            }
          }
        `,
        {
          address: account?.toLowerCase(),
          id,
        }
      )
      const arrayWinNumber: any[] = player?.bets[0]?.winNumber
      const prize = player?.bets[0]?.prize
      const amount = new BigNumber(prize ?? 0)
      if (arrayWinNumber) {
        setAlertText('')
        setWinNumber(arrayWinNumber[0])
        setPendingResult(false)
        setLoadingPlayBet(false)
        setAlertResultLastBet(true)
        playerData.fetchData()
        setArrayResultNumber(arrayWinNumber)
        setPrize(amount)
        setResult(values)
        setTypeBetResult(betType)
        setOpenModal(true)
        if (amount.gt(0)) {
          showConfetti()
        }
        /* for (let i = 0; i < arrayWinNumber.length; i++) {
          setAlertText((txt) => txt + `Your bet: ${values[0]} - Result: ${arrayWinNumber[i]} \n`)
          await delay(1000)
        }
        if (amount.gt(0)) {
          setAlertText((txt) => txt + `You win ${getFullDisplayBalance(amount, 18, 4)} CHIPS!`)
          showConfetti()
        } else {
          setAlertText((txt) => txt + `You lose :(`)
        } */
      } else {
        // eslint-disable-next-line no-promise-executor-return
        await delay(2000)
        getLastBet(id)
      }
    }
    if (requestId) {
      getLastBet(requestId)
    }
  }, [account, apiUrl, requestId])

  useInterval(() => {
    setRandomNumber(Math.floor(Math.random() * 100))
  }, 100)

  useEffect(() => {
    const tempMinValue = 500
    setMinBetAmount(tempMinValue)
    setMaxBetAmount(tempMinValue * 10)
  }, [])

  useEffect(() => {
    if (values && values[0] >= 0) {
      if (enumBetType.Under === betType) {
        setWinChance(values[0])
        setPayoutInCaseWin((100 / values[0]) * 0.93)
      } else {
        setWinChance(99 - values[0])
        setPayoutInCaseWin((100 / (99 - values[0])) * 0.93)
      }
    }
  }, [values, betType, maxValue])

  const changeBetType = () => {
    const isUnder = betType === enumBetType.Under
    setBetType(isUnder ? enumBetType.Over : enumBetType.Under)
    setMinValue(isUnder ? 10 : 1)
    setMaxValue(isUnder ? 98 : 90)
    setBetColors(betColors.reverse())
    if (!isUnder && values[0] > 90) {
      setValue([90])
    }

    if (isUnder && values[0] < 10) {
      setValue([10])
    }
  }

  const handleFocus = (event: { target: { select: () => any } }) => event.target.select()

  const betX2 = () => {
    if (betAmount * 2 <= maxBetAmount) {
      setBetAmount(betAmount * 2)
    } else {
      setBetAmount(maxBetAmount)
    }
  }

  const betMiddle = () => {
    setBetAmount(betAmount / 2)
  }

  const betMin = () => {
    setBetAmount(minBetAmount)
  }

  const betMax = () => {
    setBetAmount(maxBetAmount)
  }

  const rollDice = async () => {
    setWinNumber('00')
    setAttempting(true)
    setAlertResultLastBet(false)
    try {
      // validate if min amount
      if (betAmount < minBetAmount) {
        throw new Error('Error invalid bet amount')
      }

      const betsForPlay = []
      if (automaticMode) {
        for (let i = 0; i < totalAutoBets; i += 1) {
          betsForPlay.push({ amount: BigBetAmount.toFixed(0), number: values[0], betType })
        }
      } else {
        betsForPlay.push({ amount: BigBetAmount.toFixed(0), number: values[0], betType })
      }

      const response = await diceContract?.playBet(betsForPlay)?.catch((err: any) => {
        console.log(err)
        setAttempting(true)
        setAttempting(false)
        setLoadingPlayBet(false)
        setPendingResult(false)
      })
      const receipt = await response?.wait()
      if (response?.hash) {
        const eventFilter = diceContract?.filters.newBet()
        const events = await diceContract?.queryFilter(eventFilter!, receipt?.blockHash)
        const requestId = events?.[0].args.id.toString()
        setLoadingPlayBet(true)
        setAttempting(false)
        await delay(5000)
        setRequestId(requestId)
        playerData.fetchData()
      }
    } catch (error) {
      console.log(error)
      setAttempting(false)
      setLoadingPlayBet(false)
      setPendingResult(false)
    }
  }

  return (
    <>
      <StyleDice.DiceContainer isMobile={isMobile}>
        {alertResultLastBet && <div style={{ whiteSpace: 'pre-wrap' }}> {alertText} </div>}
        <StyleDice.SectionDice>
          <StyleDice.DiceStyled
            under={betType === enumBetType.Under}
            rolling={loadingPlayBet && betType === enumBetType.Over}
          >
            <div>{betType === enumBetType.Under ? values[0] : loadingPlayBet ? randomNumber : WinNumber}</div>
          </StyleDice.DiceStyled>
          <StyleDice.DiceStyled
            under={betType === enumBetType.Over}
            rolling={loadingPlayBet && betType === enumBetType.Under}
          >
            <div>{betType === enumBetType.Over ? values[0] : loadingPlayBet ? randomNumber : WinNumber}</div>
          </StyleDice.DiceStyled>
        </StyleDice.SectionDice>
        <StyleDice.SectionText>
          <div>
            <Trans>Roll Under</Trans>
          </div>
          <div>
            <Trans>Roll Over</Trans>
          </div>
        </StyleDice.SectionText>
        <div style={{ height: 40 }} />
        <StyleDice.SectionRange>
          <StyleDice.SectionRangeSliderContainer>
            <div style={{ marginRight: '0.8rem' }}>0</div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                flexWrap: 'wrap',
                margin: '0',
                width: '100%',
              }}
            >
              {/* eslint-disable */}
              <Range
                values={values}
                step={STEP}
                min={minValue}
                max={maxValue}
                disabled={loadingPlayBet || attempting}
                onChange={(newValues) => setValue(newValues)}
                renderTrack={({ props, children }) => (
                  <div
                    onMouseDown={props.onMouseDown}
                    onTouchStart={props.onTouchStart}
                    style={{
                      ...props.style,
                      height: '20px',
                      display: 'flex',
                      width: '100%'
                    }}
                  >
                    <div
                      ref={props.ref}
                      style={{
                        height: '10px',
                        width: '100%',
                        borderRadius: '15px',
                        background: getTrackBackground({
                          values,
                          colors: betColors,
                          min: minValue,
                          max: maxValue
                        }),
                        alignSelf: 'center'
                      }}
                    >
                      {children}
                    </div>
                  </div>
                )}
                renderThumb={({ props }) => (
                  <div
                    {...props}
                    style={{
                      ...props.style,
                      height: '25px',
                      width: '25px',
                      borderRadius: '25px',
                      backgroundColor: '#FFF',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <div
                      style={{
                        position: 'absolute',
                        top: '-45px',
                        padding: '4px',
                        borderRadius: '4px'
                      }}
                    >
                      <ThemedText.Body
                        fontFamily="Arial,Helvetica Neue,Helvetica,sans-serif"
                        fontWeight="bold"
                        fontSize={18}
                      >
                        {values[0].toFixed(0)}
                      </ThemedText.Body>
                    </div>
                  </div>
                )}
              />
              {/* eslint-disable */}
            </div>
            <div style={{ marginLeft: '0.8rem' }}>99</div>
          </StyleDice.SectionRangeSliderContainer>
        </StyleDice.SectionRange>
        <div style={{ height: 20 }} />
        <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '1rem', alignItems: 'center' }}>
          <Toggle id="multi-bet-toggle" isActive={automaticMode} toggle={() => setAutomaticMode(!automaticMode)} />
          <ThemedText.Body ml="0.5rem">
            <Trans>Automatic</Trans>
          </ThemedText.Body>
        </div>
        <div style={{ height: 5 }} />
        <StyleDice.SectionConfiguration>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              marginTop: '0.5rem',
              width: '100%'
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', width: '33.33%', alignItems: 'center' }}>
              <ThemedText.Body color="#fff" fontSize={isMobile ? '12px' : '16px'}>
                <Trans>Win Chance</Trans>
              </ThemedText.Body>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', width: '40%', alignItems: 'center' }}>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <ThemedText.Body color="#fff" marginRight="0.5rem" fontSize={isMobile ? '12px' : '16px'}>
                  <Trans>Bet Amount</Trans>
                </ThemedText.Body>
                <div
                  onClick={betX2}
                  style={
                    isMobile
                      ? {
                          cursor: 'pointer',
                          border: '1px solid #fff',
                          padding: '2px',
                          fontSize: '12px',
                          marginRight: '0.2rem',
                          color: '#fff'
                        }
                      : { cursor: 'pointer', border: '1px solid #fff', padding: '4px', color: '#fff' }
                  }
                >
                  X2
                </div>
                <div
                  onClick={betMiddle}
                  style={
                    isMobile
                      ? {
                          cursor: 'pointer',
                          border: '1px solid #fff',
                          padding: '2px',
                          fontSize: '12px',
                          marginRight: '0.2rem',
                          color: '#fff'
                        }
                      : { cursor: 'pointer', border: '1px solid #fff', padding: '4px', color: '#fff' }
                  }
                >
                  1/2
                </div>
                <div
                  onClick={betMin}
                  style={
                    isMobile
                      ? {
                          cursor: 'pointer',
                          border: '1px solid #fff',
                          padding: '2px',
                          fontSize: '12px',
                          color: '#fff',
                          marginRight: '0.2rem'
                        }
                      : { cursor: 'pointer', border: '1px solid #fff', padding: '4px', color: '#fff' }
                  }
                >
                  Min
                </div>
                <div
                  onClick={betMax}
                  style={
                    isMobile
                      ? {
                          cursor: 'pointer',
                          border: '1px solid #fff',
                          padding: '2px',
                          fontSize: '12px',
                          marginRight: '0.2rem',
                          color: '#fff'
                        }
                      : { cursor: 'pointer', border: '1px solid #fff', padding: '4px', color: '#fff' }
                  }
                >
                  Max
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', width: '33.33%', alignItems: 'center' }}>
              <ThemedText.Body color="#fff" fontSize={isMobile ? '12px' : '16px'}>
                <Trans>Balance</Trans>
              </ThemedText.Body>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              marginTop: '1rem',
              width: '100%'
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', width: '33.33%', alignItems: 'center' }}>
              <ThemedText.Body color="#fff" fontSize={isMobile ? '12px' : '16px'}>
                {winChance} %
              </ThemedText.Body>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', width: '33.33%', alignItems: 'center' }}>
              <StyleDice.SectionInputBet
                value={betAmount}
                thousandSeparator={true}
                onFocus={handleFocus}
                disabled={loadingPlayBet || attempting}
                onValueChange={(values) => {
                  const { value } = values
                  setBetAmount(Number(value))
                }}
                onBlur={() => {
                  if (betAmount < minBetAmount) {
                    setBetAmount(minBetAmount)
                  } else if (betAmount > maxBetAmount) {
                    setBetAmount(maxBetAmount)
                  }
                }}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', width: '33.33%', alignItems: 'center' }}>
              <ThemedText.Body color="#fff" fontSize={isMobile ? '12px' : '16px'}>
                <NumberFormat
                  value={getFullDisplayBalance(playerData.chipsBalance, 18, 2)}
                  displayType="text"
                  thousandSeparator
                  decimalScale={4}
                />
              </ThemedText.Body>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-evenly',
              alignItems: 'center',
              marginTop: '1rem'
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginTop: '1rem'
              }}
            >
              <ThemedText.Body color="#fff" fontSize={isMobile ? '12px' : '16px'}>
                <Trans>Multiplier</Trans>
              </ThemedText.Body>
              <div style={isMobile ? { fontSize: '12px', color: '#fff' } : { color: '#fff' }}>
                <NumberFormat
                  value={payoutInCaseWin}
                  displayType="text"
                  thousandSeparator
                  decimalScale={4}
                  prefix="x"
                />
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginTop: '1rem'
              }}
            >
              <ThemedText.Body color="#fff" fontSize={isMobile ? '12px' : '16px'}>
                <Trans>Payout on Win</Trans>
              </ThemedText.Body>
              <div style={isMobile ? { fontSize: '12px', color: '#fff' } : { color: '#fff' }}>
                <NumberFormat
                  value={payoutInCaseWin * betAmount}
                  displayType="text"
                  thousandSeparator
                  decimalScale={4}
                />
              </div>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-evenly',
              alignItems: 'center',
              marginTop: '1rem'
            }}
          >
            <ButtonLight
              type="button"
              onClick={changeBetType}
              disabled={betType === enumBetType.Under || loadingPlayBet || attempting}
              width="40%"
              margin="auto"
            >
              <Trans>Under</Trans>
            </ButtonLight>
            <ButtonLight
              type="button"
              onClick={changeBetType}
              disabled={betType === enumBetType.Over || loadingPlayBet || attempting}
              width="40%"
              margin="auto"
            >
              <Trans>Over</Trans>
            </ButtonLight>
          </div>
          {automaticMode && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'space-around',
                marginTop: '1rem'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  margin: 'auto',
                  width: '50%'
                }}
              >
                <ThemedText.Body color="#fff" fontSize={isMobile ? '12px' : '16px'}>
                  <Trans># Auto Bets</Trans>
                </ThemedText.Body>
                <StyleDice.SectionInputAutoBet
                  isMobile={isMobile}
                  type="number"
                  min="2"
                  max="10"
                  value={totalAutoBets}
                  onFocus={handleFocus}
                  onChange={(e) => setTotalAutoBets(Number(e.target.value))}
                  onBlur={() => {
                    if (totalAutoBets <= 1) {
                      setTotalAutoBets(2)
                    } else if (totalAutoBets > 10) {
                      setTotalAutoBets(10)
                    }
                  }}
                />
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  margin: 'auto',
                  width: '50%'
                }}
              >
                <ThemedText.Body color="#fff" fontSize={isMobile ? '12px' : '16px'}>
                  <Trans>You Pay</Trans>
                </ThemedText.Body>
                <ThemedText.Body color="#fff">
                  <NumberFormat
                    value={betAmount * totalAutoBets}
                    displayType="text"
                    thousandSeparator
                    decimalScale={4}
                  />
                </ThemedText.Body>
              </div>
            </div>
          )}
        </StyleDice.SectionConfiguration>
        <div style={{ height: 20 }} />
        {account ? (
          <ButtonPrimary
            onClick={rollDice}
            disabled={!haveFunds || betAmount === 0 || loadingPlayBet || attempting || hightAmount}
          >
            {attempting ? (
              <>
                <Trans>Confirming</Trans>{' '}
                <CustomLightSpinner
                  src={Circle}
                  alt="loader"
                  size={'18px'}
                  style={{ marginLeft: '0.5em', textDecoration: 'bold' }}
                />{' '}
              </>
            ) : loadingPlayBet ? (
              <>
                <Trans>Rolling</Trans>{' '}
                <CustomLightSpinner
                  src={Circle}
                  alt="loader"
                  size={'18px'}
                  style={{ marginLeft: '0.5em', textDecoration: 'bold' }}
                />{' '}
              </>
            ) : haveFunds ? (
              hightAmount ? (
                <Trans>Invalid Amount</Trans>
              ) : (
                <Trans>Roll Dice</Trans>
              )
            ) : (
              <Trans>Insufficient CHIPS</Trans>
            )}
          </ButtonPrimary>
        ) : (
          <ButtonPrimary onClick={toggleWalletModal}>
            <Trans>Connect wallet</Trans>
          </ButtonPrimary>
        )}
      </StyleDice.DiceContainer>
      <div style={{ height: 30 }} />
      <HistoryDice winNumber={WinNumber} />
      <ResultModal
        isOpen={openModal}
        amount={prize}
        arrayWinNumber={arrayResultNumber}
        onDismiss={handleDismissModal}
        numbers={result}
        type={typeBetResult}
      />
    </>
  )
}

export default DiceBet
